export const TENANT_ID = 'scfhp';

export const MASONRY = {
  API_VERSION: 2,
  CUSTOM_WIDGET_TYPE_HEALTHLINK_LOGO: 'healthlink_logo',
  HEALTH_JOURNEY_MODULE_KEY: 'health_journey',
  CUSTOM_WIDGET_TYPE_HEALTH_JOURNEY: 'health_journey',
  MESSAGING_MODULE_KEY: 'messaging',
  CUSTOM_WIDGET_TYPE_MESSAGING: 'recent_messages',
  MODULE_KEY_CLAIMS: 'claims',
  CUSTOM_WIDGET_TYPE_CLAIMS: 'recent_claims_cards',
  CUSTOM_WIDGET_TYPE_ACTIVITY: 'activity_stack',
};

export const HealthAssessment = {
  campaignId: '2bufDAAikyXO8JKm1L1o4r',
  activityId: '2VLBZ2tDAOVBYVAoo0ExUR',
};

export const SENTRY_CONSTANTS = {
  OWNERSHIP_TEAM: 'scfhp-web',
  NO_INFO_AVAILABLE: 'no info available',
};

export const COMMUNICATION_OPTIONS = {
  SMS: 'sms',
  EMAIL: 'email',
};

export const MESSAGE_TYPES = {
  GET_APP_INIT_DETAILS: 'get_app_init_details',
  GET_WIDGET_CONTAINER: 'get_widget_container',
};

export const PATHS = {
  COMMUNICATION_PREFERENCES: '/settings/communication-preferences',
  ABOUT: '/settings/about',
  EN_TERMS_OF_USE_ROUTE: 'https://www.scfhp.com/terms-and-conditions/',
  EN_PRIVACY_POLICY: 'https://www.scfhp.com/privacy-policy/',
  CONTACT_US: '/contact_info',
  FORMS: '/forms',
  CHANGE_PCP: '/change-pcp',
  AUTH_STATUSES_PAGE: '/authorization-statuses',
  AUTH_STATUS_PAGE: '/authorization-status',
  FORM_STATUSES_PAGE: '/submitted-requests',
  FORM_STATUS_PAGE: '/form-status',
  IOS_APP_LINK: 'https://apps.apple.com/us/app/myscfhp/id6740147300',
  ANDRIOD_APP_LINK:
    'https://play.google.com/store/apps/details?id=com.scfhp.android',

  PERSONAL_INFO: '/settings/personal-information',
  EN_SUBMIT_REQUEST_DUALCONNECT:
    'https://www.scfhp.com/forms/grievance-and-appeal-form-dualconnect/',
  EN_SUBMIT_REQUEST_MEDICAL:
    'https://www.scfhp.com/healthcare-plans/medi-cal/frequently-asked-questions/grievance-and-appeal-process/',
  EN_CALENDER_OF_EVENTS: 'https://crc.scfhp.com/crc-calendar/',
  EN_COVERAGE_DETERMINATION_FORM:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/534390fc09f64d48bd15c212df0e31f0/h4045_23106e-redetermination-request-form.pdf',
  EN_NON_DESCRIMINARTION_DUALCONNECT:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/9b0c49630e1a4c8eafaef4e177a42bc2/h4045_25088e_c-nondiscrimination-notice-english.pdf',
  ES_NON_DESCRIMINARTION_DUALCONNECT:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/b04883903c0345e997abe9c533222f57/h4045_25088s_c-nondiscrimination-notice-spanish.pdf',
  VT_NON_DESCRIMINARTION_DUALCONNECT:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/2153bd07983e42419410c745deaea9bb/h4045_25088v_c-nondiscrimination-notice-vietnamese.pdf',
  CN_NON_DESCRIMINARTION_DUALCONNECT:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/9cc246a0d6dc49628bdbd6cbad078700/h4045_25088c_c-nondiscrimination-notice-simplified-chinese.pdf',
  TG_NON_DESCRIMINARTION_DUALCONNECT:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/46bc9c337b8a439a958b53e7d494fdab/h4045_25088t_c-nondiscrimination-notice-tagalog.pdf',
  RU_NON_DESCRIMINARTION_DUALCONNECT:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/5d070373398c455593595c2f3723a932/h4045_25088r_c-nondiscrimination-notice-russian.pdf',
  EN_NON_DESCRIMINARTION_MEDICAL:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/2cf893ded3f940d6898d299599f4eaf6/50769e-mc-nondiscrimination-notice.pdf',
  ES_NON_DESCRIMINARTION_MEDICAL:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/40fc2c5e493941d99ca074ed9a81eee6/50769s-mc-nondiscrimination-notice.pdf',
  VT_NON_DESCRIMINARTION_MEDICAL:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/d826e6611998414aae4a7ed56eabe21c/50769v-mc-nondiscrimination-notice.pdf',
  CN_NON_DESCRIMINARTION_MEDICAL:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/1fe020f6d1a64b3a9631b9209c4cc867/50769c-mc-nondiscrimination-notice.pdf',
  TG_NON_DESCRIMINARTION_MEDICAL:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/a1d1386a8b4445e887212744040627d3/50769t-mc-nondiscrimination-notice.pdf',
  RU_NON_DESCRIMINARTION_MEDICAL:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/4a52255a2eb0421a952028b7585baf2a/50769r-mc-nondiscrimination-notice.pdf',
  LANGUAGE_ASSISTANCE_MEDICAL:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/5baaa37e3dbe4e509b4ee89dbcabe9d0/50784-mc-noa-language-assistance-services-ncqa.pdf',
  LANGUAGE_ASSISTANCE_DUALCONNECT:
    'https://res.cloudinary.com/dpmykpsih/image/upload/santa-clara-site-299/media/c44950ea51b140eebb04b7cab1e12f2e/25095-noa-english-standard-ncqa-standalone.pdf',
  FACEBOOK: 'https://www.facebook.com/scfhp/',
  DELEGATE_CONTACT_MEDICAL:
    'https://www.scfhp.com/media/p/17337/41579-scfhp-medi-cal-quick-reference-guide-final.pdf',
  DELEGATE_CONTACT_DUALCONNECT:
    'https://www.scfhp.com/media/p/12686/41446-scfhp-dualconnect-quick-reference-guide-final.pdf',
  INSTAGRAM: 'https://www.instagram.com/scfhp/',
  WEBSITE: 'https://www.scfhp.com',
  LINKEDIN: 'http://www.linkedin.com/company/santa-clara-family-health-plan',
};

export const REST_ENDPOINTS = {
  USER: '/v1/users',
};

export const NOT_ELIGIBLE_CONTACT = [
  {
    title: 'Medi-Cal',
    email: 'CallCenterManagement@scfhp.com',
    phone: '1-833-987-2347',
    hoursId: 'STR_HOURS_MEDI_CAL',
  },
  {
    title: 'DualConnect',
    email: 'ContactDualConnect@scfhp.com',
    phone: '1-833-987-2347',
    hoursId: 'STR_HOURS_DUALCONNECT',
  },
];

export const US_STATES = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

export const APP_STORE_LINK =
  'https://apps.apple.com/us/app/myscfhp/id6740147300';
export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.scfhp.android&hl=en_US';
